const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- app-welcome ---
let __fez_component_0;
{
const STEPS = ['Name', 'Username', 'Picture']
const USERNAME = /^[a-z0-9][a-z0-9._-]{2,31}$/

// A username as the server keeps it (normalize_username), with what is wrong with it, if anything.
// People need 6 or more with an _ or a .; names without either are kept for system admins.
function checkUsername(raw, admin) {
  const value = raw.trim().toLowerCase()
  if (!value) return { value, error: 'Pick a username.' }
  if (value.length < 3 || value.length > 32) return { value, error: admin ? 'Use 3 to 32 characters.' : 'Use 6 to 32 characters.' }
  if (!/^[a-z0-9]/.test(value)) return { value, error: 'Start with a letter or digit.' }
  if (!USERNAME.test(value)) return { value, error: 'Use only letters, digits, ., - and _.' }
  if (!admin && value.length < 6) return { value, error: 'Use 6 to 32 characters.' }
  if (!admin && !/[._]/.test(value)) return { value, error: 'Include an _ or a ., like ana_horvat or ana.horvat.' }
  return { value, error: '' }
}

function usernameHint(admin) {
  return admin ? '3 to 32 of a-z, 0-9, ., - and _, starting with a letter or digit.' : '6 to 32 of a-z, 0-9, ., - and _, with at least one _ or ., like ana_horvat or ana.horvat.'
}

// Text as a username, other characters joined by _: "Marko Marić" -> marko_maric; dino.reic stays.
function slug(text) {
  return (text || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9._-]+/g, '_').replace(/^[._-]+/, '').slice(0, 32).replace(/[._-]+$/, '')
}

// A suggestion from the name, else the email's local part, when it makes a valid username.
function suggestion(name, email, admin) {
  return [slug(name), slug((email || '').split('@')[0])].find(value => !checkUsername(value, admin).error) || ''
}
__fez_component_0 = class {
  init() {
    const me = this.globalState.me || {}
    this.state.step = 0
    this.state.name = me.name || ''
    this.state.username = suggestion(me.name, me.email, this.globalState.isAdmin)
    this.state.suggested = this.state.username
    this.state.nameError = ''
    this.state.usernameError = ''
    this.state.available = null
    this.state.checking = false
    this.state.saving = false
    this.state.checked = ''
    if (this.state.username) this.check(this.state.username)
  }

  typeName(value) {
    this.state.name = value
    if (value.trim()) this.state.nameError = ''
  }

  // Checks a well-formed username once typing pauses for 300 ms.
  typeUsername(value) {
    this.state.username = value
    this.state.available = null
    this.state.usernameError = ''
    if (checkUsername(value, this.globalState.isAdmin).error) return
    this.setTimeout(() => {
      if (this.state.username === value) this.check(value)
    }, 300)
  }

  async check(raw) {
    const { value, error } = checkUsername(raw, this.globalState.isAdmin)
    if (error) return
    this.state.checking = true
    this.state.checked = value
    try {
      const result = await window.App.api('user/username_check', { username: value }, { silent: true })
      if (this.state.checked !== value) return
      this.state.available = result.available
      this.state.usernameError = result.available ? '' : 'Someone already has this username.'
    } catch (error) {
      if (this.state.checked === value) this.state.usernameError = error.details?.username || error.message
    } finally {
      if (this.state.checked === value) this.state.checking = false
    }
  }

  // Moves on from the step in view when it is complete.
  async next(event) {
    event?.preventDefault()
    if (this.state.step === 0) {
      if (!this.state.name.trim()) {
        this.state.nameError = 'Tell us your name.'
        return
      }
      // A suggestion they have not edited follows the name they gave.
      if (this.state.username === this.state.suggested) {
        this.state.username = this.state.suggested = suggestion(this.state.name, this.globalState.me?.email, this.globalState.isAdmin)
        this.state.available = null
        if (this.state.username) this.check(this.state.username)
      }
      this.state.step = 1
      return
    }
    if (this.state.step === 1) {
      const { value, error } = checkUsername(this.state.username, this.globalState.isAdmin)
      if (error) {
        this.state.usernameError = error
        return
      }
      if (this.state.available !== true || this.state.checked !== value) await this.check(value)
      if (this.state.available !== true) return
      this.state.username = value
      this.state.step = 2
      return
    }
    await this.finish()
  }

  back() {
    if (this.state.step > 0) this.state.step--
  }

  async finish() {
    this.state.saving = true
    try {
      const me = await window.App.api('user/update', { name: this.state.name.trim(), username: this.state.username }, { silent: true })
      window.App.welcomed(me)
    } catch (error) {
      if (error.details?.username) {
        this.state.usernameError = error.details.username === 'is taken' ? 'Someone already has this username.' : error.details.username
        this.state.available = false
        this.state.step = 1
      } else if (error.details?.name) {
        this.state.nameError = error.details.name
        this.state.step = 0
      } else {
        window.Toast?.error(error.message)
      }
    } finally {
      this.state.saving = false
    }
  }

  signOut() {
    window.App.signOut()
  }

  beforeRender() {
    const me = this.globalState.me || {}
    this.state.email = me.email || ''
    this.state.steps = STEPS.map((label, index) => ({ label, index, done: index < this.state.step, current: index === this.state.step }))
    this.state.last = this.state.step === STEPS.length - 1
    const admin = this.globalState.isAdmin
    const { value, error } = checkUsername(this.state.username, admin)
    this.state.usernamePlaceholder = admin ? 'ana' : 'ana_horvat'
    this.state.usernameHint = error
      ? usernameHint(admin)
      : this.state.checking
        ? 'Checking...'
        : this.state.available
          ? `@${value} is yours to take.`
          : usernameHint(admin)
  }

  CSS = `:fez {
display:block;height:100%;.page{display:grid;place-items:center;min-height:100vh;padding:var(--space-6);background:radial-gradient(1200px 600px at 10% -10%,var(--color-accent-soft),transparent 60%),radial-gradient(900px 500px at 110% 110%,var(--color-accent-soft),transparent 60%),var(--color-bg-subtle);:mobile {padding:var(--space-4)}}.card{width:100%;max-width:460px}h1{margin:0;font-size:var(--text-2xl);letter-spacing:-0.02em}.lead{margin:var(--space-2) 0 var(--space-6);color:var(--color-text-muted)}.steps{display:flex;gap:var(--space-2);margin:0 0 var(--space-6);padding:0;list-style:none}.step{flex:1;display:grid;gap:var(--space-2);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-semibold);&::before{content:'';height:4px;border-radius:var(--radius-full);background:var(--color-border)}&.done::before,&.current::before{background:var(--color-accent)}&.current{color:var(--color-text)}}.form{display:grid;gap:var(--space-5)}.question{margin:0;font-size:var(--text-lg);font-weight:var(--weight-semibold)}.helper{margin:calc(var(--space-3) * -1) 0 0;color:var(--color-text-muted);font-size:var(--text-sm)}.actions{display:flex;align-items:center;gap:var(--space-2);margin-top:var(--space-2)}.grow{flex:1}.fine{margin:var(--space-5) 0 0;color:var(--color-text-subtle);font-size:var(--text-xs);text-align:center}.fine-link{padding:0;border:0;background:none;color:inherit;font:inherit;text-decoration:underline;cursor:pointer}
}`

  HTML = `<div class="page">
<div class="card">
<div class="ui-card elevated pad-xl">
<h1>Welcome to MailCog</h1>
<p class="lead">Three quick steps before your mail opens.</p>
<ol class="steps" aria-label="Steps">
{#each state.steps as step}
<li class="step" class:done={step.done} class:current={step.current} aria-current={step.current ? 'step' : null}>{step.label}</li>
{/each}
</ol>
<form class="form" onsubmit="fez.next(event)" novalidate>
{#if state.step === 0}
<p class="question">What should people call you?</p>
<div oninput="fez.typeName(event.target.value)"><ui-input name="name" label="Your name" value={state.name} maxlength="80" error={state.nameError} autofocus></ui-input></div>
{:else if state.step === 1}
<p class="question">Pick a username</p>
<p class="helper">Others find and add you by it. It is yours alone on this server.</p>
<div oninput="fez.typeUsername(event.target.value)"><ui-input name="username" label="Username" value={state.username} placeholder={state.usernamePlaceholder} maxlength="32" icon="at" hint={state.usernameError ? '' : state.usernameHint} error={state.usernameError} autofocus></ui-input></div>
{:else}
<p class="question">Your picture</p>
<p class="helper">Keep this one or upload your own. You can change it later in Settings.</p>
<avatar-picker name={state.name}></avatar-picker>
{/if}
<div class="actions">
{#if state.step > 0}
<ui-button type="button" variant="ghost" icon="arrow-left" label="Back" onclick="fez.back()"></ui-button>
{/if}
<span class="grow"></span>
<ui-button type="submit" variant="primary" icon_right={state.last ? 'check' : 'arrow-right'} label={state.last ? 'Done' : 'Next'} :loading="state.saving"></ui-button>
</div>
</form>
<p class="fine">Signed in as {state.email}. Not you? <button type="button" class="fine-link" onclick="fez.signOut()">Sign out</button></p>
</div>
</div>
</div>`
};
}

Fez('app-welcome', __fez_component_0);

export default __fez_component_0;
